module.exports = __webpack_public_path__ + "static/media/ceremony.1809017c.svg";